/**
 * @flow
 * @relayHash 941870b506312ec097173264467a01b5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateContractorInput = {|
  firstName: string,
  lastName?: ?string,
  nickname?: ?string,
  email: string,
  prerequisiteFlag?: ?string,
  clientMutationId?: ?string,
|};
export type CreateContractorMutationVariables = {|
  input: CreateContractorInput
|};
export type CreateContractorMutationResponse = {|
  +createContractor: ?{|
    +newContractor: ?{|
      +id: string,
      +firstName: ?string,
      +lastName: ?string,
      +email: ?string,
    |}
  |}
|};
export type CreateContractorMutation = {|
  variables: CreateContractorMutationVariables,
  response: CreateContractorMutationResponse,
|};
*/


/*
mutation CreateContractorMutation(
  $input: CreateContractorInput!
) {
  createContractor(input: $input) {
    newContractor {
      id
      firstName
      lastName
      email
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateContractorInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createContractor",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateContractorPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "newContractor",
        "storageKey": null,
        "args": null,
        "concreteType": "ContractorNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "firstName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "lastName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "email",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateContractorMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateContractorMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateContractorMutation",
    "id": null,
    "text": "mutation CreateContractorMutation(\n  $input: CreateContractorInput!\n) {\n  createContractor(input: $input) {\n    newContractor {\n      id\n      firstName\n      lastName\n      email\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bb16a0dea980875dbd18a3dadc96661c';
module.exports = node;
